import React, {Component} from "react";
import Title from "../../components/Title";
import Breadcrumbs from "../../components/UI/Breadcrumbs";
import Layout from "../../containers/Layout";
import OrderAdd from "../../containers/OrderAdd";


class OrderAddPage extends Component {
    render() {
        return (
            <Layout>
                <Title>Новый заказ</Title>
                <Breadcrumbs links={[
                    {name: 'Главная', url: '/'},
                    {name: 'Заказы', url: '/orders'},
                    {name: 'Новый заказ', url: '/orders/add'}
                ]}/>
                <OrderAdd/>
            </Layout>
        );
    }
}

export default OrderAddPage;
